/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
import queries_2_3_5 from './2.3.5';
import queries_2_4_0 from './2.4.0';
import queries_2_4_1ce from './2.4.1ce';
import queries_2_4_1ee from './2.4.1ee';
import queries_2_4_2ce from './2.4.2ce';
import queries_2_4_2ee from './2.4.2ee';
import queries_2_4_3ce from './2.4.3ce';
import queries_2_4_3ee from './2.4.3ee';
import queries_2_4_4ce from './2.4.4ce';
import queries_2_4_4ee from './2.4.4ee';

export default {
    '2.3.5': {
        ...queries_2_3_5
    },
    '2.4.0': {
        ...queries_2_4_0
    },
    '2.4.1ce': {
        ...queries_2_4_1ce
    },
    '2.4.1ee': {
        ...queries_2_4_1ee
    },
    '2.4.2ce': {
        ...queries_2_4_2ce
    },
    '2.4.2ee': {
        ...queries_2_4_2ee
    },
    '2.4.3ce': {
        ...queries_2_4_3ce
    },
    '2.4.3ee': {
        ...queries_2_4_3ee
    },
    '2.4.4ce': {
        ...queries_2_4_4ce
    },
    '2.4.4ee': {
        ...queries_2_4_4ee
    }
};

export const minUIDSupportVersion = '2.4.2ce';
